import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class UnCancelClaimDto {
  @Field(t => Int)
  claimId!: number
}
